<template>
    <section class="notenart-detail-sv">
        <template v-if="busy">
            <CenteredMessage spinner="true">Daten werden geladen</CenteredMessage>
        </template>
        <template v-else>
            <b-table-simple class="table-plain" responsive small borderless>
                <b-thead>
                    <b-tr>
                        <b-th style="width: 100%"></b-th>
                        <b-th>Version</b-th>
                        <b-th>Archiv-Nr.</b-th>
                        <b-th>geliehen von</b-th>
                        <b-th class="text-center" style="width: 200px">Datum</b-th>
                        <b-th class="text-right" style="width: 20px">Ausgabe</b-th>
                        <b-th class="text-right" style="width: 20px">Rücknahme</b-th>
                        <b-th class="text-right" style="width: 20px">Typ</b-th>
                        <b-th class="text-center" style="width: 40px">Aktion</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr v-for="item in items" :key="item.id" :class="getTableClass(item.type)">
                        <b-td></b-td>
                        <b-th class="mv-nowrap">{{item.description}}</b-th>
                        <b-th class="mv-nowrap">{{item.archivnr}}</b-th>
                        <b-td class="mv-nowrap">{{item.geliehen_von}}</b-td>
                        <b-td class="mv-nowrap">{{item.datum}}</b-td>
                        <b-td class="text-right">
                            <template v-if="item.type === 'issued'">-{{item.anzahl}}</template>
                            <template v-else-if="item.type === 'issue_canceled'">
                                <strike>{{item.anzahl}}</strike>
                            </template>
                            <template v-else>&nbsp;</template>
                        </b-td>
                        <b-td class="text-right">
                            <template
                                v-if="item.type === 'returned' || item.type === 'error_entry'"
                            >{{item.anzahl}}</template>
                            <template v-else-if="item.type === 'return_canceled'">
                                <strike>{{item.anzahl}}</strike>
                            </template>
                            <template v-else>&nbsp;</template>
                        </b-td>
                        <b-td class="text-right">{{getTag(item.type)}}</b-td>
                        <b-td class="text-center">
                            <template
                                v-if="item.type != 'issue_canceled' && item.type != 'return_canceled'"
                            >
                                <b-dropdown size="sm" :disabled="disableActions" dropleft>
                                    <template v-slot:button-content>
                                        <template v-if="item.busy">
                                            <Spinner small variant="light" class="mx-3" />
                                        </template>
                                        <template v-else>Aktionen</template>
                                    </template>
                                    <b-dropdown-item
                                        v-if="checkRight('write')"
                                        @click="cancelTransaction(item)"
                                    >
                                        <font-awesome-icon
                                            icon="exclamation-triangle"
                                            class="text-warning mr-1"
                                        />Stornieren
                                    </b-dropdown-item>
                                    <b-dropdown-item
                                        v-if="checkRight('write') && (item.type === 'issued' || item.type === 'returned')"
                                        @click="printReceipt(item.id)"
                                    >
                                        <font-awesome-icon icon="receipt" class="ml-1 mr-3" />Quittung drucken
                                    </b-dropdown-item>
                                </b-dropdown>
                            </template>
                        </b-td>
                    </b-tr>
                </b-tbody>
                <b-tfoot>
                    <tr>
                        <b-th colspan="5" class="text-right">Summe</b-th>
                        <b-th class="text-right">-{{totals.issued}}</b-th>
                        <b-th class="text-right">{{totals.returned_total}}</b-th>
                        <b-th class="text-right">{{totals.total}}</b-th>
                        <b-th></b-th>
                    </tr>
                </b-tfoot>
            </b-table-simple>
        </template>
    </section>
</template>

<script>
import CommonView from "@/mixins/CommonView/CommonView";
import Rights from "@/mixins/Rights/Rights";
import { ApiFactory } from "@/api/ApiFactory.js";
import { BlobUtil } from "@/utils/BlobUtil.js";
import CenteredMessage from "@/components/CenteredMessage/CenteredMessage";
import Spinner from "@/components/Spinner/Spinner";

const NotentransferSVApi = ApiFactory.get("notentransferSV");

import "./NotentransferDetailSV.scss";

export default {
    name: "NotentransferDetailSV",
    props: [
        "sv_id",
        "noten_id",
        "werk_id",
        "notentyp",
        "totals",
        "refresh",
        "disableActions"
    ],
    mixins: [CommonView, Rights],
    components: {
        CenteredMessage,
        Spinner
    },
    data() {
        return {
            api: NotentransferSVApi
        };
    },
    watch: {
        refresh: {
            handler() {
                this.fetch();
            }
        }
    },
    methods: {
        async fetch() {
            this.busy = true;
            const response = await this.api.getTransactions(
                this.sv_id,
                this.noten_id,
                this.werk_id,
                this.notentyp
            );
            if (response.ok) {
                var items = response.json.collection;
                var prevId = null;
                items = items.map(item => {
                    item.busy = false;
                    if (prevId == item.noten_art_id) {
                        item.description = null;
                        item.archivnr = null;
                    }
                    prevId = item.noten_art_id;
                    return item;
                });
                this.items = items;
                this.registerRights(response);
            }
            this.busy = false;
        },
        async cancelTransaction(item) {
            item.busy = true;
            this.$emit("cancelation", item.id);
        },
        async printReceipt(id) {
            const response = await NotentransferSVApi.getReceipt(id);
            if (response.ok) {
                BlobUtil.downloadBlob(response.blob, "Quittung.pdf");
            }
        },
        getTag(transactionType) {
            switch (transactionType) {
                case "issued":
                    return "AUS";
                case "returned":
                    return "RÜCK";
                case "error_entry":
                    return "FEHL";
                case "issue_canceled":
                    return "STOR";
                case "return_canceled":
                    return "STOR";
            }
        },
        getTableClass(transactionType) {
            switch (transactionType) {
                case "issued":
                    return "table-danger";
                case "returned":
                    return "table-success";
                case "error_entry":
                    return "table-secondary";
                default:
                    return "table-secondary";
            }
        }
    }
};
</script>